var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-success"},[_vm._t("default"),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("×")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12807464","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/boxes/SuccessBox.vue
// module id = null
// module chunks = 